import React from 'react'
import Slider from "react-slick";

const settings = {
  dots: false,
  arrows: false,
  slidesToShow: 4,
  infinite: true,
  autoplay: true,
  slidesToScroll: 1,
  pauseOnHover: false,
  cssEase: "linear",
  autoplaySpeed: 0,
  speed: 5000,
  remove: true,
  centerMode: true,
  responsive: [
    {
      breakpoint: 2560,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export default function HaldiGallery({haldigallery}) {
  return (
    <>
    <section className="haldipage-gallery">
        <Slider {...settings}>
            {haldigallery.map((img, i) => (
            <div key={i}>
                <img src={img.src} className="img-responsive" alt="gallery" loading="lazy"/>
            </div>
            ))}
        </Slider>
    </section>
    </>
  )
}
